import { MODE_CALCUL_MANUEL } from '@/configuration/general';

export default function genererModeCalculHonoraire() {
  return {
    modeCalcul: MODE_CALCUL_MANUEL,
    applicableSurLocation: false,
    applicableSurTlpe: false,
    applicableSurDivers: false,
    commentaire: null,
    montantForfaitHt: null,
    pourcentage: null,
  };
}
